import axios from 'axios';

import {
  SITECONTENT_TYPE,
  SITECONTENT_LIST_REQUEST,
  SITECONTENT_LIST_RESPONSE,
  SITECONTENT_LIST_ERROR,
  SITECONTENT_GET_REQUEST,
  SITECONTENT_GET_RESPONSE,
  SITECONTENT_GET_ERROR,
  SITECONTENT_ADD_REQUEST,
  SITECONTENT_ADD_RESPONSE,
  SITECONTENT_ADD_ERROR,
  SITECONTENT_UPDATE_REQUEST,
  SITECONTENT_UPDATE_RESPONSE,
  SITECONTENT_UPDATE_ERROR,
  SITECONTENT_DELETE_REQUEST,
  SITECONTENT_DELETE_RESPONSE,
  SITECONTENT_DELETE_ERROR,
  STASH_COPY_DATA,
  CLEAR_COPY_DATA
} from 'redux/reducers/siteContent';

import { getQueryFilter } from 'utils/request';

export const stashCopy = data => ({
  type: STASH_COPY_DATA,
  data
});

export const clearCopy = () => ({
  type: CLEAR_COPY_DATA
});

export const getContentList = ({ page = 1, limit, filter = {}, sort }) => {
  return async dispatch => {
    // dispatch, getState
    dispatch({ type: SITECONTENT_LIST_REQUEST });
    filter.type = SITECONTENT_TYPE;
    try {
      const params = { page, limit, filter: getQueryFilter(filter) };
      if (sort) {
        params.sort = JSON.stringify(sort);
      }
      const response = await axios.get('/api/data/list/content', {
        params
      });
      dispatch({
        type: SITECONTENT_LIST_RESPONSE,
        data: response?.data?.list,
        pages: response?.data?.pages || 0,
        count: response?.data?.count || 0,
        // response,
        page
      });
    } catch (error) {
      dispatch({ type: SITECONTENT_LIST_ERROR, data: error.message });
    }
  };
};

export const getSiteContentById = id => {
  return async dispatch => {
    // dispatch, getState
    dispatch({ type: SITECONTENT_GET_REQUEST });
    try {
      const response = await axios.get(`/api/data/get/content/${id}`);
      dispatch({
        type: SITECONTENT_GET_RESPONSE,
        data: response?.data
      });
    } catch (error) {
      dispatch({ type: SITECONTENT_GET_ERROR, data: error.message });
    }
  };
};

export const saveData = ({ data, siteContent }) => {
  return async dispatch => {
    if (!data) {
      console.error('error, missing data, cannot update');
      return;
    }

    data.type = SITECONTENT_TYPE;

    const params = {
      doc: true,
      data
    };
    let apiPathAction = 'add',
      requestAction = SITECONTENT_ADD_REQUEST,
      responseAction = SITECONTENT_ADD_RESPONSE,
      errorAction = SITECONTENT_ADD_ERROR;
    if (siteContent) {
      params.id = siteContent;
      apiPathAction = 'update';
      requestAction = SITECONTENT_UPDATE_REQUEST;
      responseAction = SITECONTENT_UPDATE_RESPONSE;
      errorAction = SITECONTENT_UPDATE_ERROR;
    }

    dispatch({ type: requestAction, siteContent });

    if (!data.block || !data.slug) {
      // race condition with this error dispatch??? timeout=1 gives a tick
      setTimeout(() => {
        dispatch({
          type: errorAction,
          data: 'Missing required properties, make sure to add a name, slug and some content.'
        });
      }, 1);
      return;
    }

    try {
      const response = await axios.post(`/api/data/${apiPathAction}/content`, params);
      if (response?.data?.result) {
        dispatch({ type: responseAction, data: response?.data?.doc });
      } else {
        dispatch({ type: errorAction, data: 'failed to save the siteContent' });
      }
    } catch (error) {
      dispatch({
        type: errorAction,
        data: error?.response?.data?.message || 'unknown error'
      });
    }
  };
};

export const deleteContent = ({ id }) => {
  return async dispatch => {
    if (!id) {
      console.error('error, missing id, cannot delete');
      return;
    }
    console.log('ok try to delete siteContent', id);
    dispatch({ type: SITECONTENT_DELETE_REQUEST, id });
    try {
      const response = await axios.delete(`/api/data/delete/content/${id}`);
      console.log('delete siteContent response', response?.data);
      dispatch({ type: SITECONTENT_DELETE_RESPONSE, id, data: response });
    } catch (error) {
      console.warn('error deleting, dispatch the error', error);
      dispatch({ type: SITECONTENT_DELETE_ERROR, data: error });
    }
  };
};
